import './App.css';
import cleaningPerson from './clean.png';
import bucket from './bucket.png';

function App() {
  return (
    <div className="bg-[#AF0] min-h-screen">
      <div>
      <h1 className="text-5xl md:text-7xl font-bold text-center p-5">
        Express House Cleaning
      </h1>  
      <p className="text-3xl font-bold text-center px-5">
        Apartments, Houses, & Offices
      </p>
      <div className="grid grid-row md:grid-cols-3 gap-0 place-items-center px-5">
        <img className="h-24 md:h-36" src={cleaningPerson} alt="person cleaning" />
        <div>
          <p className="text-xl text-center">
            We have experience & good references reasonable prices reliable & responsible Available 24/7 & all areas
          </p>
          <p className="text-xl text-center">
            Call or text anytime
          </p>
          <p className="text-xl text-center">
            Ask for Paola
          </p>
        </div>
        <img className="h-24 md:h-36" src={bucket} alt="person cleaning" />
      </div>
          <p className="text-2xl font-bold text-center">
            <a href="tel:323-217-9353">323-217-9353</a> • <a href="tel:323-453-3517">323-453-3517</a>
          </p>
      </div>
    </div>
  );
}

export default App;
